
import {
  Vue,
  Component,
  Prop,
  Model,
  Watch,
} from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Cascader,
  Select,
  Option,
} from 'element-ui';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Cascader,
  },
})

export default class TSearch extends Vue {
  @Prop({
    required: false,
  }) value!: any;

  @Prop({
    type: Boolean,
    default: false,
  }) advanced!: boolean;

  @Prop() placeholder!: string;

  @Prop({
    type: Number,
    default: 1,
  }) searchType!: number;

  @Prop({
    default: false,
  }) searchData!: any;

  private activate: boolean = false;

  get searchValue() {
    return this.value;
  }

  set searchValue(value: any) {
    this.$emit('change', value);
    this.$emit('update:value', value);
  }

  get simpleStyle() {
    return this.advanced ? { width: '120px', paddingLeft: '14px' } : '';
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索点击事件
   */
  handleActivate() {
    this.activate = !this.activate;
    this.$emit('activate', this.activate);
  }
}
